// These hints explain the existing API restrictions; the API remains authoritative.
const partialReason = 'Já há vans publicadas neste lote. Edite os passageiros das vans pendentes na montagem. Trecho e horário dos pedidos e a retirada do lote ficam bloqueados.';
const executionReason = 'Há vans deste pedido em operação. Os ajustes devem ser feitos na van; o pedido de origem e a retirada do planejamento ficam bloqueados.';

export const planningOrderEditReason = (program, partial = false) => {
  if (partial || program.planejamento_parcial) return partialReason;
  if (program.status === 'em_execucao') return executionReason;
  if (program.status === 'concluida') return 'Pedido concluído. A edição do pedido de origem está encerrada.';
  if (program.status === 'cancelada') return 'Pedido cancelado. A edição do pedido de origem está encerrada.';
  if (program.operacional?.pode_editar === false || !['rascunho', 'planejada'].includes(program.status)) {
    return 'Edição indisponível neste estado. Atualize o andamento para consultar a situação do pedido.';
  }
  return '';
};

export const planningUndoReason = (programs, partial = false) => {
  if (partial || programs.some(program => program.planejamento_parcial)) return partialReason;
  if (programs.some(program => program.status === 'em_execucao')) return executionReason;
  if (programs.some(program => ['concluida', 'cancelada'].includes(program.status))) {
    return 'O lote contém pedido concluído ou cancelado e não pode voltar para A fazer.';
  }
  if (programs.some(program => program.operacional?.pode_desfazer_planejamento === false || program.status !== 'planejada')) {
    return 'Retirada do planejamento indisponível neste estado. Atualize o andamento para consultar a situação do lote.';
  }
  return '';
};
